import IPCheckbox from './IPCheckBox'

export default IPCheckbox
